import { atom } from "jotai";

export const isNotificationsNudgeModalOpenAtom = atom(false);
